import { Component } from '@angular/core';
import { ElementBase } from "../element-base";

@Component({
  selector: 'app-element-multi-line',
  templateUrl: './element-multi-line.component.html',
  styleUrl: './element-multi-line.component.scss'
})
export class ElementMultiLineComponent extends ElementBase {

}
